import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ProjectActionTypes } from '../../redux/project/project.types';
import Header from '../../components/home/header/header.component';
import GreenLine from '../../components/greenline/greenline.component';
import FooterNew from '../../components/footernew/footernew.component';
import { removeFirstChar } from '../../utils/utils';
import { language as MAINLANG } from '../../utils/lang';

import './hakkimizda.page.styles.scss';

const HakkimizdaPage = () => {
  const xprops = useSelector(state => state);
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);
  const setParent = (value) => dispatch({type: ProjectActionTypes.SET_PARENT, value: value });  
   
  if(!mounted){
    if (xprops.language === undefined){
      setParent(removeFirstChar(MAINLANG.TR.routes.aboutUs));  
    }else{
      setParent(removeFirstChar(xprops.language.routes.aboutUs));  
    }
  }  

  useEffect(() =>{
    setMounted(true);
    window.scrollTo(0,0);
  },[]);  

    return(
      <React.Fragment>
        <div className="homeWrapper">
          <Header />
          <div className="newSectionWrapper">
          <GreenLine classx="spacebottom"/>
          <div className="newContentLayerWrapper">
            <div className="subContentSectionWrapper">
              <h1 className="subContentTitle">{xprops.project.language.keywords.aboutUs}</h1>
              {
                xprops.project.language.short === "TR" ?
                  <React.Fragment>
                    <p className="subContentParagraph">
                      "Sensiz Olmaz Sessiz Olmaz" projesi, Mayıs 2021'de hayata geçirildi. Çıkış amacı, kadınların fikirleri ve uzmanlıklarıyla daha görünür hale gelmesini teşvik etmek, böylece kadına yönelik ayrımcılığı azaltmaktır.          
                    </p>
                    <p className="subContentParagraph">
                    Kadınların toplumsal ve iş yaşamındaki rollerinin daha iyi anlaşılması ve farklılık gözetmeksizin bakış açılarının kamusal alanda daha görünür olması, toplumsal cinsiyet eşitliği için ileriye dönük olumlu etkiler yaratacaktır.
                    </p>
                    <p className="subContentParagraph">
                      Girişimin kurucuları ve üstlenicileri, medya ve sivil toplum sektörlerinde deneyimli ve çeşitli uzmanlık alanlarına sahip kişilerden oluşmaktadır. 
                    </p>
                  </React.Fragment>
                  :
                  <React.Fragment>
                    <p className="subContentParagraph">
                      The Women Voices platform was launched in May 2020. Its main goal is to encourage the visibility of women's ideas and expertise, and thereby reducing discrimination against women. Better understanding the societal and professional roles of women and making diverse perspectives visible in the public sphere will create positive effects for gender equality in the future.
                    </p>
                    <p className="subContentParagraph">
                      The founders and contributors of the initiative are experienced individuals with diverse expertise in the media and civil society sectors. Among the founders are Özge Genç, Sabiha Senyücel Gündoğar, Semin Gümüşel Güner, Ayşe Karabat and Ayşe Yırcalı. The team members involved in the project collaborate to amplify women's voices and support women from different segments of society.
                    </p>
                  </React.Fragment>
              }
            </div>
          </div>
        </div>
        </div>
        <FooterNew />
      </React.Fragment>
    );
};

export default HakkimizdaPage;